export const INSPECT_STATUS_LIST_MUTATION = "INSPECT_STATUS_LIST_MUTATION";
export const INSPECT_KEYWORD_LIST_MUTATION = "INSPECT_KEYWORD_LIST_MUTATION";
